/* eslint-disable react/prop-types */
import React from 'react';
import './RecommendedLabel.scss';

const { PHRASE_TRANSLATIONS } = process.env.REACT_APP_MARKET_VALUES;

const RecommendedLabel = () => {
    return <p className="label">{PHRASE_TRANSLATIONS.recommendedLabel}</p>;
};

export default RecommendedLabel;
